import { render, staticRenderFns } from "./verifyResendCaptcha.vue?vue&type=template&id=5a76fd9a&scoped=true"
import script from "./verifyResendCaptcha.vue?vue&type=script&lang=js"
export * from "./verifyResendCaptcha.vue?vue&type=script&lang=js"
import style0 from "./verifyResendCaptcha.vue?vue&type=style&index=0&id=5a76fd9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a76fd9a",
  null
  
)

export default component.exports